<template>
	<div class="head-container ">
		<div class="header main-w">
			<div class="row cb">
				<div class="col">
					<p class="link" @click="$router.push('/')">中国医学科学院健康科普研究中心</p>
					<p>Health Science Research Center of Chinese Academy of Medical Sciences</p>
				</div>
				<div class="row cc tel-box">
					<img src="@/assets/tel.png" class="tel" />
					<div class="col text-box" v-if="false">
						<span class="tel-text"></span>
						<span class="mobile-text">176-1002-8051&nbsp;/&nbsp;182-1100-3670</span>
					</div>
					<div class="col text-box" style="height: 27px;" v-else><span class="tel-text">176-1002-8051</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.head-container {
	background-color: #017575;
	margin-bottom: 16px;

	.header {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 40px;
		// background: url(../../assets/header.png) repeat-x center;
		// background-size: cover;
		height: 170px;
		color: #ffffff;
		p:nth-of-type(1) {
			font-size: 38px;
		}
		p:nth-of-type(2) {
			font-size: 19px;
			word-spacing: 1.5px;
		}
		.tel-box {
			.tel {
				width: 40px;
				height: 40px;
				margin-right: 14px;
			}
			.text-box {
				height: 44px;
				justify-content: space-between;
				.tel-text {
					color: #ffffff;
					font-size: 27px;
					line-height: 27px;
				}
				.mobile-text {
					color: #ffffff;
					font-size: 13px;
					line-height: 13px;
				}
			}
		}
	}
}
</style>
